import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PinSearchbarService {
  @Output() pinSearchbarClickedEvent = new EventEmitter();
  constructor() { }

  pinSearchbarClicked(pinned: boolean) {
    this.pinSearchbarClickedEvent.emit(pinned);
  }
}
